import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.dsfai.ir/api", // Base URL for the API
  timeout: 15000, // Timeout after 5 seconds
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export default axiosInstance;
